module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.8b18d65d6824460ad376.woff";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Bold-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.woff
// module chunks = 2